// extracted by mini-css-extract-plugin
export var arrows = "_3p-6";
export var decrementer = "_3p-a";
export var disabled = "_3p-4";
export var error = "_3p-1";
export var hiddenText = "_3p-b";
export var incrementer = "_3p-9";
export var input = "_3p-8";
export var inputWrapper = "_3p-0";
export var leadingIcon = "_3p-c";
export var readonly = "_3p-3";
export var regular = "_3p-7";
export var small = "_3p-5";
export var warning = "_3p-2";